var _rect, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPng = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FDC9A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 28.167C36.5 32.881 36.5 35.2381 35.0355 36.7025C33.5711 38.167 31.214 38.167 26.5 38.167H21.5C16.786 38.167 14.4289 38.167 12.9645 36.7025C11.5 35.2381 11.5 32.881 11.5 28.167V19.8337C11.5 15.1196 11.5 12.7626 12.9645 11.2981C14.4289 9.83366 16.786 9.83366 21.5 9.83366H26.5C31.214 9.83366 33.5711 9.83366 35.0355 11.2981C36.5 12.7626 36.5 15.1196 36.5 19.8337V28.167Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 18,
    r: 3,
    stroke: "#1D1D1D",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 25.5941L13.8047 23.7024C15.0038 22.7182 16.8109 22.7747 17.9375 23.8315L23.5819 29.1264C24.4861 29.9746 25.9095 30.0903 26.9558 29.4005L27.3482 29.1418C28.8537 28.1493 30.8907 28.2643 32.2585 29.419L36.5 33",
    stroke: "#1D1D1D",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPng);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PNG.e441430ddb93e845459093b18d03a890.svg";